export default __webpack_public_path__ + "madfit-screen-fifth.bb157d3c.png";